import { Box, Typography } from '@mui/material';
import { BilldaLogo } from '@billda/shared-ui';
import { useGreeting } from '../hooks/useGreeting';
import { useGetDashboardPeriodInfo } from '../hooks/useGetDashboardPeriodInfo';
import { PeriodBadge } from './PeriodBadge';
import { formatWeekLabel, formatDateRange } from '../utils/periodFormatting';

export function DashboardHeader() {
  const greeting = useGreeting();
  const { data: periodInfo, isLoading } = useGetDashboardPeriodInfo();

  const periods = periodInfo?.periods ?? [];
  const weekLabel = formatWeekLabel(periods);
  const dateRange = formatDateRange(periods);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: { xs: 'flex-start', sm: 'center' },
        flexDirection: { xs: 'column', sm: 'row' },
        gap: 2,
      }}
    >
      {/* Left: Logo + Title + Greeting */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Box
          sx={{
            width: 48,
            height: 48,
            borderRadius: '12px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: theme =>
              theme.palette.mode === 'dark'
                ? 'rgba(255, 200, 0, 0.1)'
                : 'rgba(255, 180, 0, 0.15)',
            flexShrink: 0,
          }}
        >
          <BilldaLogo variant="icon" width={40} />
        </Box>
        <Box>
          <Typography variant="h4" fontWeight={600}>
            Dashboard
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {greeting}
          </Typography>
        </Box>
      </Box>

      {/* Right: Period info */}
      <PeriodBadge
        weekLabel={weekLabel}
        dateRange={dateRange}
        isLoading={isLoading}
      />
    </Box>
  );
}
